/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useState, useEffect } from 'react';
import { AppContext } from '../../App';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import BetslipLoader from '../../data/betslip/BetslipLoader';
import { ShopContext } from '../../data/shop/ShopConf';
import { classIf } from '../../data/utils/classIf';
import { getConfiguration } from '../../data/utils/configuration';
import { labels } from '../../data/labels';

import Coupon from './Coupon';
import FastbetCart from './FastbetCart';
import ReservationBox from './ReservationBox';
import ReservationDetail from '../../data/betslip/reservation-detail/ReservationDetail';
import SettingsDropdown from './SettingsDropdown';

function Betslip(props) {
    const appContext = React.useContext(AppContext);
    const betslipContext = React.useContext(BetslipContext);
    //const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
    const [dropdownStyle, setDropdownStyle] = useState(null);
    const settingsDropdownToggle = useRef(null);
    const showSettingsDropdown = betslipContext.isBetslipSettingsVisible();
    const shopContext = React.useContext(ShopContext);
    const conf = getConfiguration();
    const fastbetAliasEnabled = shopContext.enabled && conf.fbt === 'XR';

    useEffect(() => {
        function listener() {
            appContext.toggleBetslip();
        }
        window.addEventListener('close-betslip', listener);
        return () => window.removeEventListener('close-betslip', listener);
    }, []);
    
    function toggleSettingsDropdown(e) {
        e.stopPropagation();
    	//setShowSettingsDropdown(!showSettingsDropdown);
        betslipContext.toggleBetslipSettings();
        
        // Before the first render we must compute the dropdown position
        // relative to the toggle button
//        if (!showSettingsDropdown && !dropdownStyle) {
//            const btn = settingsDropdownToggle.current;
//            let btnTop = btn.offsetTop;
//            let btnRight = btn.offsetLeft + btn.offsetWidth;
//            let btnHeight = btn.offsetHeight;
//            setDropdownStyle({
//                top: btnTop + btnHeight / 2 + "px",
//                left: btnRight + 5 + "px"
//            });
//        }
    }
    
    function toggleReservationBox() {
        betslipContext.toggleReservationBox();
    }
    
    function showBetslipCoupon(keyCoupon) {
    	betslipData.selectedCoupon = keyCoupon + "";
    	betslipContext.setBetslipData(betslipData, true);
    	betslipContext.restoreReservationBoxStatus();
    }

    let betslipData = betslipContext.getBetslipData();
    const couponKey = betslipData?.selectedCoupon;
    const coupon = betslipData?.coupons?.[couponKey];
    let reservations = betslipContext.getReservations();
    reservations = reservations == null? [] : reservations;

    // Before the first render we must compute the dropdown position
    // relative to the toggle button    
    if (!showSettingsDropdown && !dropdownStyle && settingsDropdownToggle && settingsDropdownToggle.current) {
        const btn = settingsDropdownToggle.current;
        let btnTop = btn.offsetTop;
        let btnRight = btn.offsetLeft + btn.offsetWidth;
        let btnHeight = btn.offsetHeight;
        setDropdownStyle({
            top: btnTop + btnHeight / 2 + "px",
            left: btnRight + 5 + "px"
        });
    }

    return <>
    { betslipData &&
        <main id="panel" className="panel carrello-mobile">
            <div id="betslip-container" className="container-carrello-mobile">
                <div className="container-carrello-mobile_intestazione">
                    {showSettingsDropdown &&
                        <SettingsDropdown style={dropdownStyle} toggle={() => betslipContext.toggleBetslipSettings()} />
                    }
                    <div className="container-carrello-mobile_intestazione_inner-container">
                        {!shopContext.enabled &&
                            <button id="settings-dropdown-toggle" ref={settingsDropdownToggle} className={"position-relative" + classIf(showSettingsDropdown, 'selected')} onClick={toggleSettingsDropdown}>
                                <i className="fas fa-cog fa-lg"></i>
                            </button>
                        }
                        <button onClick={toggleReservationBox}>
                            <i className="fas fa-ticket-alt fa-lg"></i>
                            <div className="button_custom_notification">{reservations.length}</div>
                        </button>
                    </div>
                    <div className="container-carrello-mobile_intestazione_inner-container_numero-ticket">
                        <p>{labels['betslip.header.ticket']}<span>&nbsp;{couponKey}/5</span></p>
                        <div className="counter_circle">
                            <p>{coupon.selections.length}</p>
                        </div>
                    </div>
                    <div className="container-carrello-mobile_intestazione_inner-container">
                        <button id="betslip-close-button" onClick={() => {appContext.toggleBetslip()}}><i className="fas fa-times-circle fa-lg"></i></button>
                    </div>
                </div>
                {
                	fastbetAliasEnabled && (<FastbetCart showedReservationBox={betslipContext.showedReservationBox} />)
                }
                <div className="scAggiuntive d-flex justify-content-around align-intems-center bg-colore-1 nav nav-tabs" role="tablist" id="scAggiuntiva">
                    {Object.keys(betslipData.coupons).map(function(key) {
                        return (
                            <a key={"couponSelectorKey" + key}
                                className={"pointer scAggiuntiva" + (key === betslipData.selectedCoupon? ' active' : '')} 
                                href-disabled="#"
                                onClick={() => showBetslipCoupon(key)}>
                                {key}
                                {betslipData.coupons[key].selections.length > 0 &&
                                    <span>&bull;</span>
                                }
                            </a> 
                        )
                    })}
                </div>
                {betslipContext.showedReservationBox ?
                    <ReservationBox couponKey={couponKey} />
                    :
                    <>
                        <div className="tab-content tabelleSchedineNumerate" id="tabelleSchedineNumerate">
                            {Object.keys(betslipData.coupons).map(function(key) {
                                    const showable = key === betslipData.selectedCoupon;
                                    if (showable) {
                                        return (<Coupon showable={"true"} couponKey={key} key={"couponKey" + key} />)
                                    } else {
                                        return null;
                                    }
                                })
                            }
                        </div>
                    </>
                }
            </div>
            <BetslipLoader />
            {betslipContext.showReservationDetail &&
                <ReservationDetail />
            }
        </main>
   }
   </>
}

export default Betslip;